<template>
<nav aria-label="breadcrumb" class="breadcrumb-area">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">よくあるご質問</li>
  </ol>
</nav>
  <div class="container">

      <div class="top--section">
          <Faq />
      </div>
  </div>
</template>
<script setup>
import Faq from "@/components/Static/Faq.vue";
</script>
